// @flow

import React, { type Node, useEffect, useState } from 'react';

import { Modal } from '@zapier/common-components';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import TrialCloseButton from '../TrialCloseButton';
import routes from './routes';

import { type Size } from '@zapier/design-system-company/src/types';

type Props = {
  /** The current account id (for submitting survey) */
  accountId: number,
  /** The index of the view to show when the modal first opens */
  initialView?: string,
  /** Callback to be executed when the modal is closed */
  onClose: () => void,
  /** Payment app for injecting in payment page */
  paymentApp: Node,
  /** Size */
  size: Size,
  /** End date of trial */
  trialEndDate: string,
};
/**
 * Shown to the user when they start a new companies trial.
 */
const TrialWelcomeModal = (props: Props) => {
  const { trackEvent } = useTrackingContext();
  const [activeView, setActiveView] = useState(
    props.initialView || 'companyInfo'
  );
  const onRoute = route => setActiveView(route);

  const currentRoute = routes[activeView] || routes.companyInfo;

  useEffect(() => {
    trackEvent(`company-trial-modal-${activeView}-view`, {
      accountId: props.accountId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeView]);

  return (
    <Modal
      closeOnOutsideClick={true}
      maxWidth={600}
      onClose={props.onClose}
      overflowX="visible"
      overflowY="visible"
      padding={0}
      renderCloseButton={() => <TrialCloseButton onClose={props.onClose} />}
    >
      <currentRoute.Component
        accountId={props.accountId}
        onClose={props.onClose}
        onRoute={onRoute}
        paymentApp={props.paymentApp}
        size={props.size}
        trialEndDate={props.trialEndDate}
      />
    </Modal>
  );
};

export default TrialWelcomeModal;
